import { useState } from 'react';
import { Link } from 'react-router-dom';

export function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const onSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // Auth flow not yet implemented — see docs/design/domains/authentication.md
    };

    return (
        <section className="bg-slate-50">
            <div className="mx-auto flex max-w-md flex-col px-6 py-20">
                <h1 className="text-3xl font-bold tracking-tight text-ptm-ink">Log in</h1>
                <p className="mt-2 text-slate-600">
                    Sign in to view your quotes, track jobs, and re-order past parts.
                </p>

                <form
                    onSubmit={onSubmit}
                    className="mt-10 rounded-2xl border border-slate-200 bg-white p-8 shadow-sm"
                >
                    <label className="block text-sm font-medium text-ptm-ink">
                        Email
                        <input
                            type="email"
                            required
                            autoComplete="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="mt-1.5 block w-full rounded-md border border-slate-300 px-3 py-2.5 text-ptm-ink shadow-sm outline-none transition focus:border-ptm-accent focus:ring-2 focus:ring-ptm-accent/20"
                        />
                    </label>

                    <label className="mt-5 block text-sm font-medium text-ptm-ink">
                        Password
                        <input
                            type="password"
                            required
                            autoComplete="current-password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="mt-1.5 block w-full rounded-md border border-slate-300 px-3 py-2.5 text-ptm-ink shadow-sm outline-none transition focus:border-ptm-accent focus:ring-2 focus:ring-ptm-accent/20"
                        />
                    </label>

                    <div className="mt-3 text-right">
                        <Link
                            to="/forgot-password"
                            className="text-sm font-medium text-ptm-accent no-underline hover:underline"
                        >
                            Forgot password?
                        </Link>
                    </div>

                    <button
                        type="submit"
                        className="mt-6 w-full rounded-md bg-ptm-accent px-5 py-3 font-semibold text-white shadow-sm transition hover:bg-orange-500"
                    >
                        Log in
                    </button>
                </form>

                <p className="mt-6 text-center text-sm text-slate-600">
                    New to Protomation?{' '}
                    <Link to="/signup" className="font-semibold text-ptm-accent no-underline hover:underline">
                        Create an account
                    </Link>
                </p>
            </div>
        </section>
    );
}
